export default [
  {
    path: '/app/user/map',
    name: 'mapMarkerUser',
    components: {
      default: () => import('../../views/mapDevice/indexUser.vue')
    }
  },
  {
    path: '/app/user/map/multipleView',
    name: 'multipleViewUser',
    components: {
      default: () => import('../../views/viewMulti/indexUser.vue')
    }
  },
  {
    path: '/app/user/monitoring',
    name: 'MonitorViewUser',
    components: {
      default: () => import('../../views/monitor/indexMonitor.vue')
    }
  },
  {
    path: '/app/user/ftp',
    name: 'ftpPagesUser',
    components: {
      default: () => import('../../views/ftp/indexFtpUser.vue')
    }
  },
  {
    path: '/app/user/ftp/history',
    name: 'ftpHistoryUser',
    components: {
      default: () => import('../../views/ftp/indexFtpHistoryUser.vue')
    }
  },
  {
    path: '/app/user/integration/nature',
    name: 'natureSettingsUser',
    components: {
      default: () => import('../../views/integration/natureSettings.vue')
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/mapUser.js